export class DeleteOrganizationVM {
    organizationID: number;
    deletedBy: number;
    deletedOn: Date;
}
